import React from 'react'
import PropTypes from 'prop-types'
import { RenderAorB, RenderIf, concatClasses } from '../../utils/fns'

import ReactHtmlParser from 'react-html-parser'

const NoticeMessage = (props) => {
  const { level, icon, title, description } = props

  return RenderIf(
    description,
    <div className={concatClasses('notice', level ? `-${level}` : '')}>
      {RenderAorB(
        icon,
        <span className="material-icons">{icon}</span>,
        <span className="material-icons">info</span>,
      )}

      <div className="notice__text">
        {RenderIf(title, <div className="notice__header">{title}</div>)}
        <div className="notice__body">{ReactHtmlParser(description)}</div>
      </div>
    </div>,
  )
}

NoticeMessage.propTypes = {
  level: PropTypes.string, icon: PropTypes.string, title: PropTypes.string, description:PropTypes.string
}

NoticeMessage.defaultProps = {
  level: 'info',
}

export default NoticeMessage